// Demo mode (no backend needed): start the app with REACT_APP_PROMO_SCHEDULE_MOCK=true.
// OFF unless that variable is exactly "true". The dummy data lives in ./mockPromoSchedule and is
// loaded on demand, so it is never part of the normal code path. Add
// REACT_APP_PROMO_SCHEDULE_MOCK_FLAG=off to see the unchanged (flag off) UI in demo mode.
export const USING_PROMO_SCHEDULE_MOCK = process.env.REACT_APP_PROMO_SCHEDULE_MOCK === "true";

/**
 * @param {"listing"|"dish-options"|"target-options"|"create"} kind
 * @returns {Promise<{data: object}>} shaped like the axios response callAPI resolves with
 */
export const mockPromoApi = async (kind, payload) => {
  const mock = await import("./mockPromoSchedule");
  return mock.handleMockRequest(kind, payload);
};
